import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["typeRadio", "parentSelect", "pricingTiers", "tierTemplate", "inventoryList", "inventoryTemplate", "kitSection", "kitComponentList", "kitComponentTemplate", "isKitInput", "productPackList", "productPackTemplate"]

    connect() {
        this.toggleType()
    }

    toggleType() {
        const type = this.typeRadioTargets.find(radio => radio.checked)?.value

        // Reset visibility
        this.parentSelectTarget.classList.add("hidden")
        this.kitSectionTarget.classList.add("hidden")
        if (this.isKitInputTarget) this.isKitInputTarget.value = "false"

        if (type === 'variant') {
            this.parentSelectTarget.classList.remove("hidden")
        } else if (type === 'kit') {
            this.kitSectionTarget.classList.remove("hidden")
            if (this.isKitInputTarget) this.isKitInputTarget.value = "true"
        }
    }

    addPriceTier(event) {
        event.preventDefault()
        const content = this.tierTemplateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        this.pricingTiersTarget.insertAdjacentHTML('beforeend', content)
    }

    removePriceTier(event) {
        event.preventDefault()
        this.removeRow(event.target.closest('.price-tier-row'))
    }

    addInventory(event) {
        event.preventDefault()
        const content = this.inventoryTemplateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        this.inventoryListTarget.insertAdjacentHTML('beforeend', content)
    }

    removeInventory(event) {
        event.preventDefault()
        this.removeRow(event.target.closest('.inventory-row'))
    }

    addKitComponent(event) {
        event.preventDefault()
        const content = this.kitComponentTemplateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        this.kitComponentListTarget.insertAdjacentHTML('beforeend', content)
    }

    removeKitComponent(event) {
        event.preventDefault()
        this.removeRow(event.target.closest('.kit-component-row'))
    }

    addProductPack(event) {
        event.preventDefault()
        const content = this.productPackTemplateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        this.productPackListTarget.insertAdjacentHTML('beforeend', content)
    }

    removeProductPack(event) {
        event.preventDefault()
        this.removeRow(event.target.closest('.product-pack-row'))
    }

    removeRow(wrapper) {
        if (wrapper.dataset.newRecord === "true") {
            wrapper.remove()
        } else {
            wrapper.style.display = 'none'
            wrapper.querySelector("input[name*='_destroy']").value = 1
        }
    }
}
